<script lang="ts">

    import ConfettiGenerator from "confetti-js";
    import { onDestroy, onMount } from "svelte";

    let width: number;
    let height: number;
    let canvasElement: HTMLCanvasElement;
    let confetti: ConfettiGenerator;

    onMount(() => {

        confetti = new ConfettiGenerator({
            target: canvasElement,
            max: "500",
            size: "1.5",
            animate: true,
            props: ["circle", "square", "triangle", "line"],
            colors: [
                [165, 104, 246],
                [230, 61, 135],
                [0, 199, 228],
                [253, 214, 126],
            ],
            clock: "35",
            rotate: true,
            width: width,
            height: height,
            start_from_edge: true,
            respawn: true,
        });

        confetti.render();

    });

    onDestroy(() => {
        confetti.clear();
    });

</script>

<div class="confetti-container" bind:clientWidth={width} bind:clientHeight={height}>
    <canvas bind:this={canvasElement} {width} {height}></canvas>
</div>

<style lang="scss">

    .confetti-container {
        width: 100%;
        height: 100%;
    }

</style>
